/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Featureddiscounts_Title1Inputs */

const id_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Unggulan`)
};

const ms_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskaun Pilihan`)
};

const da_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhævede Rabatter`)
};

const de_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgestellte Rabatte`)
};

const en_us2_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Discounts`)
};

const es_es2_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos destacados`)
};

const es_mx2_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos destacados`)
};

const fil_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Itinatampok na Diskwento`)
};

const fr_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réductions en vedette`)
};

const it_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti in evidenza`)
};

const hu_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiemelt kedvezmények`)
};

const nl_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgelichte kortingen`)
};

const no_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhevede rabatter`)
};

const pl_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polecane promocje`)
};

const pt_br2_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Discounts`)
};

const pt_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descontos em destaque`)
};

const ro_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduceri recomandate`)
};

const fi_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suositellut alennukset`)
};

const sv_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvalda rabatter`)
};

const vi_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá nổi bật`)
};

const tr_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne Çıkan İndirimler`)
};

const cs_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší slevy`)
};

const bg_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Препоръчани отстъпки`)
};

const ru_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемые скидки`)
};

const uk_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендовані знижки`)
};

const ar_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخصومات المميزة`)
};

const hi_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ीचर्ड छूट`)
};

const th_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนลดเด่น`)
};

const ja_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目の割引`)
};

const zh_cn2_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Discounts`)
};

const zh_hant1_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Discounts`)
};

const ko_components_featureddiscounts_title1 = /** @type {(inputs: Components_Featureddiscounts_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Discounts`)
};

/**
* | output |
* | --- |
* | "Featured Discounts" |
*
* @param {Components_Featureddiscounts_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_featureddiscounts_title1 = /** @type {((inputs?: Components_Featureddiscounts_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Featureddiscounts_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_featureddiscounts_title1(inputs)
	if (locale === "ms") return ms_components_featureddiscounts_title1(inputs)
	if (locale === "da") return da_components_featureddiscounts_title1(inputs)
	if (locale === "de") return de_components_featureddiscounts_title1(inputs)
	if (locale === "en-US") return en_us2_components_featureddiscounts_title1(inputs)
	if (locale === "es-ES") return es_es2_components_featureddiscounts_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_featureddiscounts_title1(inputs)
	if (locale === "fil") return fil_components_featureddiscounts_title1(inputs)
	if (locale === "fr") return fr_components_featureddiscounts_title1(inputs)
	if (locale === "it") return it_components_featureddiscounts_title1(inputs)
	if (locale === "hu") return hu_components_featureddiscounts_title1(inputs)
	if (locale === "nl") return nl_components_featureddiscounts_title1(inputs)
	if (locale === "no") return no_components_featureddiscounts_title1(inputs)
	if (locale === "pl") return pl_components_featureddiscounts_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_featureddiscounts_title1(inputs)
	if (locale === "pt") return pt_components_featureddiscounts_title1(inputs)
	if (locale === "ro") return ro_components_featureddiscounts_title1(inputs)
	if (locale === "fi") return fi_components_featureddiscounts_title1(inputs)
	if (locale === "sv") return sv_components_featureddiscounts_title1(inputs)
	if (locale === "vi") return vi_components_featureddiscounts_title1(inputs)
	if (locale === "tr") return tr_components_featureddiscounts_title1(inputs)
	if (locale === "cs") return cs_components_featureddiscounts_title1(inputs)
	if (locale === "bg") return bg_components_featureddiscounts_title1(inputs)
	if (locale === "ru") return ru_components_featureddiscounts_title1(inputs)
	if (locale === "uk") return uk_components_featureddiscounts_title1(inputs)
	if (locale === "ar") return ar_components_featureddiscounts_title1(inputs)
	if (locale === "hi") return hi_components_featureddiscounts_title1(inputs)
	if (locale === "th") return th_components_featureddiscounts_title1(inputs)
	if (locale === "ja") return ja_components_featureddiscounts_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_featureddiscounts_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_featureddiscounts_title1(inputs)
	return ko_components_featureddiscounts_title1(inputs)
});
export { components_featureddiscounts_title1 as "components.featuredDiscounts.title" }